<template>
    <div>
        <rkm-timeline>
            <rkm-timeline-item
                v-for="(item, i) in data.additionals.timeline"
                :key="i"
                :dateTime="item.dateTime"
                :title="item.title"
                :label="item.label"
                :disabled="item.disabled"
                :line-class="item.listClass"
            />
        </rkm-timeline>

        <rkm-form ref="RkmForm">
            <rkm-alert>
                <strong>Data do atendimento:</strong> {{data.model.dataAtendimento}}
            </rkm-alert>

            <rkm-row>
                <rkm-col>
                    <box-paciente :data="data" />
                </rkm-col>

                <rkm-col v-if="data.form.historicoAtendimento.length > 0">
                    <box-historico-atendimento :data="data" />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col class="d-flex">
                    <rkm-input-group-text>
                        <rkm-form-checkbox v-model="showBoxAcidenteTrabalho">
                            Acidente de trabalho
                        </rkm-form-checkbox>
                    </rkm-input-group-text>
                </rkm-col>
            </rkm-row>

            <box-acidente-trabalho v-if="showBoxAcidenteTrabalho" :data="data" :internalVisible="showBoxAcidenteTrabalho" />

            <box-fator-risco :data="data" />

            <box-alergia :data="data" />

            <box-medicamento-uso-continuo :data="data" />

            <box-medicamento-uso :data="data" />

            <box-sinal-vital :data="data" />

            <box-escala-coma-glasgow :data="data" />

            <rkm-row>
                <rkm-col :cols="showBoxGestante ? 7 : 12">
                    <box-avaliacao-antropometrica :data="data" />
                </rkm-col>

                <rkm-col
                    v-if="showBoxGestante"
                    cols="5"
                    id="gestante"
                >
                    <box-gestante :data="data" />
                </rkm-col>
            </rkm-row>

            <box-atendimento :data="data" />

            <box-classificacao-risco :data="data" funcionalidade="atendimento-triagem" />

            <box-protocolo :data="data" />

            <box-setor-encaminhamento :data="data" />

        </rkm-form>

        <ModalImpressao ref="ModalImpressao" />

        <ModalAssinaturaEletronica
            :after-sign="afterSign"
            :ref="modalAssinaturaEletronicaRefName"
            @sign="onSign"
            @skip-sign="onSkipSign"
            v-bind="modalAssinaturaEletronicaFaaProps"
        />
    </div>
</template>

<script>
// Components.
import BoxAlergia from '@/components/cadastro/cidadao/components/alergia/Index'
import BoxMedicamentoUsoContinuo from '@/components/cadastro/cidadao/components/medicamento-uso-continuo/Index'
import BoxAtendimento from './components/atendimento/Index'
import BoxAvaliacaoAntropometrica from '@/components/pronto-atendimento/components/avaliacao-antropometrica/Index'
import BoxClassificacaoRisco from '@/components/pronto-atendimento/components/classificacao-risco/Index'
import BoxEscalaComaGlasgow from '@/components/pronto-atendimento/components/escala-coma-glasgow/Index'
import BoxFatorRisco from '@/components/pronto-atendimento/components/fator-risco/Index'
import BoxGestante from '@/components/pronto-atendimento/components/gestante/Index'
import BoxHistoricoAtendimento from '@/components/pronto-atendimento/components/historico-atendimento/Index'
import BoxMedicamentoUso from '@/components/pronto-atendimento/components/medicamento-uso/Index'
import BoxPaciente from '@/components/pronto-atendimento/components/paciente/Index'
import BoxProtocolo from '@/components/pronto-atendimento/components/protocolo/Index'
import BoxSetorEncaminhamento from '@/components/pronto-atendimento/components/setor-encaminhamento/Index'
import BoxSinalVital from '@/components/pronto-atendimento/components/sinal-vital/Index'
import BoxAcidenteTrabalho from '@/components/pronto-atendimento/components/acidente-trabalho/Atendimento'
import ModalImpressao from '@/components/pronto-atendimento/impressao/components/impressao/Modal'

// Enums.
import sexo from '@/enums/cadastro/cidadao/sexo'
import unidadeMedida from '@/enums/cadastro/unidadeMedida'
import desfecho from '@/enums/pronto-atendimento/desfecho'
import tipoFormularioAcidenteTrabalho from '@/enums/pronto-atendimento/tipoFormularioAcidenteTrabalho'

// Mixins.
import { data, error, repository, unmask, prontoAtendimentoAssinaturaEletronica } from '@/mixins'

// Others.
import moment from 'moment'

// Utils.
import string from '@/utils/stringCase'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: {
        BoxAlergia,
        BoxMedicamentoUsoContinuo,
        BoxAtendimento,
        BoxAvaliacaoAntropometrica,
        BoxClassificacaoRisco,
        BoxEscalaComaGlasgow,
        BoxFatorRisco,
        BoxGestante,
        BoxHistoricoAtendimento,
        BoxMedicamentoUso,
        BoxPaciente,
        BoxProtocolo,
        BoxSetorEncaminhamento,
        BoxSinalVital,
        BoxAcidenteTrabalho,
        ModalImpressao,
    },
    computed: {
        showBoxGestante() {

            if (this.data.form.paciente.isDesconhecido) {

                return false
            }

            return this.data.form.paciente.sexo.id === this.enums.sexo.FEMININO
                && this.data.form.paciente.idade
                && this.data.form.paciente.idade.anos >= 9
                && this.data.form.paciente.idade.anos <= 60
        },
    },
    created() {
        this.repositories.atendimentoTriagem = this.getConectaSusRepository('prontoAtendimento.atendimentoTriagem');
    },
    data: () => ({
        enums: {
            sexo,
            unidadeMedida,
            desfecho,
            tipoFormularioAcidenteTrabalho,
        },
        repositories: {},
        showBoxAcidenteTrabalho: false,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        save() {

            if (this.data.model.finalizacao.desfechoId === this.enums.desfecho.EVASAO) {

                const confirm = async () => {

                    this.data.model.cancelamentoDesfecho = true

                    this.resetDesfecho()

                    this.$nextTick().then(() => this.handleSave())

                    return false
                }

                const desfecho = this.data.form.desfecho.find(desfecho => desfecho.id
                    == this.data.model.finalizacao.desfechoId).nome

                const msg = `Foi atribuído o desfecho <strong>${desfecho}</strong>. Se o atendimento for salvo sem ser finalizado, a atribuição
                    do desfecho será desfeita. Deseja continuar?`

                this.showConfirmation(msg, confirm)

                return false
            } else {

                this.handleSave()
            }
        },
        handleSave() {
            this.$refs.RkmForm.validate().then(response => {
                if (response === true) {
                    if (this.data.additionals.isEnfermeiro && this.data.model.classificacaoRiscoId === null) {
                        this.createNotification({
                            type: 'alert',
                            color: 'danger',
                            title: 'Ação não permitida',
                            message: 'É obrigatório informar a classificação de risco.'
                        })
                    }
                    else {
                        this.setLoading()

                        let formularioToracico = []

                        this.data.model.dorToracicaCaracteristicaDor.forEach(item => {

                            formularioToracico.push(item)
                        })

                        this.data.model.dorToracicaLocalizacaoDor.forEach(item => {

                            formularioToracico.push(item)
                        })

                        this.data.model.dorToracicaFatorDescadeante.forEach(item => {

                            formularioToracico.push(item)
                        })

                        this.data.model.dorToracicaDuracaoDor.forEach(item => {

                            formularioToracico.push(item)
                        })

                        this.data.model.dorToracicaFatoresRiscos.forEach(item => {

                            formularioToracico.push(item)
                        })

                        let request = {
                            dorToracica: this.data.model.dorToracica,
                            plantaoId: this.plantaoId,
                            alergias: this.data.model.alergias.map(item => {
                                return {
                                    alergiaId: item.alergia.id,
                                    criticidadeId: item.alergia.criticidade.id,
                                    reacoesObservacoes: item.alergia.reacoesObservacoes,
                                }
                            }),
                            medicamentosUsoContinuo: this.data.model.medicamentosUsoContinuo.map(item => {
                                return {
                                    medicamentoId: item.medicamento.id,
                                }
                            }),
                            atendimentoId: this.data.model.atendimentoId,
                            centroCustoIdPara: this.data.model.centroCustoIdPara,
                            classificacaoRiscoId: this.data.model.classificacaoRiscoId,
                            filaId: this.data.model.filaId,
                            prioridadeId: this.data.form.prioridadeId,
                            gestacao: {
                                dum: this.data.model.gestacao.dum ? moment(this.data.model.gestacao.dum).format('YYYY-MM-DD') : null,
                                gestante: this.data.model.gestacao.gestante,
                            },
                            fatoresRisco: this.data.model.fatoresRisco,
                            fatorRiscoOutro: this.data.model.fatorRiscoOutro,
                            historicoEnfermagem: this.data.model.historicoEnfermagem,
                            medicamentosUso: this.data.model.medicamentosUso,
                            observacoes: this.data.model.observacoes,
                            outrasAvaliacoesCondicoes: this.data.model.outrasAvaliacoesCondicoes,
                            sinaisVitais: this.data.model.sinaisVitais.map(item => {
                                return {
                                    cintura: item.cintura || null,
                                    glicemia: item.glicemia || null,
                                    intensidadeDor: item.intensidadeDor || null,
                                    pa: item.pa || null,
                                    paUnidadeMedidaId: item.pa ? item.paUnidadeMedidaId : null,
                                    pulso: item.pulso || null,
                                    respiracao: item.respiracao || null,
                                    saturacao: item.saturacao || null,
                                    temperatura: item.temperatura ? this.unMaskTemperaturaMMDG(item.temperatura) : null,
                                }
                            }),
                            escalaComaGlasgow: this.data.model.escalasComaGlasgow.map(item => {
                                return {
                                    aberturaOcularId: item.aberturaOcular.id,
                                    respostaVerbalId: item.respostaVerbal.id,
                                    respostaMotoraId: item.respostaMotora.id,
                                    reatividadePupilarId : item.reatividadePupilar.id,
                                    observacao: item.observacoes
                                }
                            }),

                            dorToracicaDataSintoma: moment(this.data.model.dorToracicaDataSintoma).format('YYYY-MM-DD'),
                            dorToracicaHoraSintoma: this.data.model.dorToracicaHoraSintoma,

                            dorToracicaDataEcgAdmissao: moment(this.data.model.dorToracicaDataEcgAdmissao).format('YYYY-MM-DD'),
                            dorToracicaHoraEcgAdmissao: this.data.model.dorToracicaHoraEcgAdmissao,

                            dorToracicaDispneia: this.data.model.dorToracicaDispneia,
                            dorToracicaFormulario: formularioToracico
                        }

                        if (this.showBoxAcidenteTrabalho) {
                            request.raat = {
                                ...this.data.model.acidenteTrabalho,
                                empresaTelefone: this.data.model.acidenteTrabalho.empresaTelefone ? this.unMaskPhone(this.data.model.acidenteTrabalho.empresaTelefone) : null,
                                acidenteData: this.getFormatedDate(this.data.model.acidenteTrabalho.acidenteData),
                                acidenteHora: this.data.model.acidenteTrabalho.acidenteHora ? this.data.model.acidenteTrabalho.acidenteHora.slice(0, 5) : null,
                                empresaOcupacaoPaciente: this.data.model.acidenteTrabalho.empresaOcupacaoPaciente ?? null
                            };
                        }

                        if (this.data.model.avaliacaoAntropometrica.massa || this.data.model.avaliacaoAntropometrica.altura) {
                            request.avaliacaoAntropometrica = {
                                altura: this.data.model.avaliacaoAntropometrica.altura,
                                alturaTipoMedidaId: this.data.model.avaliacaoAntropometrica.alturaTipoMedidaId,
                                alturaUnidadeMedidaId: this.data.model.avaliacaoAntropometrica.alturaUnidadeMedidaId,
                                massa: this.data.model.avaliacaoAntropometrica.massa,
                                massaUnidadeMedidaId: this.data.model.avaliacaoAntropometrica.massaUnidadeMedidaId,
                            }
                        }

                        if (this.data.model.finalizacao.desfechoId && !this.data.model.finalizacao.cancelamentoDesfecho) {
                            request.finalizacao = {
                                desfechoId: this.data.model.finalizacao.desfechoId,
                                cancelamentoDesfecho: this.data.model.finalizacao.cancelamentoDesfecho
                            }
                        }

                        request.cancelamentoDesfecho = this.data.model.cancelamentoDesfecho

                        this.repositories.atendimentoTriagem.store(string.camelObjectKeysToSnakeRecursive(request))
                            .then(({ data }) => {

                                const finish = () => {

                                    this.$refs.ModalImpressao.open(
                                        data.impressoes,
                                        data.atendimentoId,
                                        () => this.$emit('save')
                                    )
                                }

                                if (data.assinar) {

                                    this.afterSign = faaAssinada => {

                                        return this.repositories.atendimentoTriagem.storeFaaAssinada(data.id, {
                                            faa_assinada: faaAssinada
                                        })
                                    }

                                    this.onSign = () => finish()
                                    this.onSkipSign = () => finish()

                                    this.askToSignAtendimento(
                                        async () => this.signFaa(
                                            data.atendimentoId,
                                            [{ tipo: 'triagem', id: data.id }],
                                            `faa-${data.faaId}-atendimento-triagem-${data.id}`
                                        ),
                                        async () => finish()
                                    )
                                }
                                else {

                                    this.showSaveNotification()

                                    finish()
                                }
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                }
            })
        },
        resetDesfecho() {
            this.data.model.finalizacao = Object.assign(this.data.model.finalizacao, {
                desfechoId: null,
                evasao: {
                    motivo: null,
                }
        })},
    },
    mixins: [data, error, repository, unmask, prontoAtendimentoAssinaturaEletronica],
    props: {
        data: { type: Object, required: true },
        plantaoId: { type: [String, Number], required: true },
    },
}
</script>